import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

/**
 * Protege rutas privadas. Si el usuario no está logueado o el token expiró,
 * redirige a /login conservando la URL solicitada (returnUrl).
 */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn()) {
    return true;
  }

  // Token expirado o inexistente -> limpiar y redirigir
  auth.logout();
  return router.createUrlTree(['/login'], {
    queryParams: state.url && state.url !== '/login' ? { returnUrl: state.url } : undefined
  });
};

/**
 * Evita ver el login si ya hay sesión activa.
 */
export const loginGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isLoggedIn() ? router.createUrlTree(['/dashboard']) : true;
};

/**
 * Restringe rutas a usuarios con `is_admin = true`. Si no es admin, redirige a /dashboard.
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn() && auth.isAdmin()) return true;
  return router.createUrlTree(['/dashboard']);
};
